const config = {
  API_BASE_URL: process.env.REACT_APP_BACKEND_URL || '',
  APP_VERSION: '2.1',
  APP_NAME: 'Office Suite',
  APP_DESCRIPTION: 'Enterprise Management System',
};

export default config;
